<template>
	<div class="uk-container uk-container-expand scheduling">
		<employee-card ref="card" :display-hours="displayHours"></employee-card>
		<job-card ref="jobCard" :display-hours="displayHours"></job-card>
		<div class="uk-grid">
			<div class="uk-form-controls uk-width-1-1">
				<label class="uk-form-label">Schedule Date Range:</label>
			</div>
			<div class="uk-form-controls uk-width-1-6">
				<label class="uk-form-label" style="font-weight: normal;">From:</label>
				<datepicker ref="startDate" type="date" v-model="startDate" @input="startDateSet"
							input-class="uk-input" :use-utc=true :typeable=true :clear-button=true
							clear-button-icon="fas fa-calendar-alt"
							format="MM/dd/yyyy"></datepicker>
			</div>
			<div class="uk-form-controls uk-width-1-6">
				<label class="uk-form-label" style="font-weight: normal;">To:</label>
				<datepicker ref="endDate" type="date" v-model="endDate" @input="endDateSet"
							input-class="uk-input" :use-utc=true :typeable=true :clear-button=true
							clear-button-icon="fas fa-calendar-alt"
							format="MM/dd/yyyy"></datepicker>
			</div>
			<div class="uk-form-controls uk-width-1-6">
				<label class="uk-form-label" style="font-weight: normal;">Business Unit:</label>
				<select class="uk-select" name="bu_id" v-model="businessUnitId">
					<option :value="0">Unassigned</option>
					<option v-for="bu in businessUnits" :value="bu.id">{{ bu.name }}</option>
				</select>
			</div>
			<div class="uk-form-controls uk-width-1-6">
				<label class="uk-form-label" style="font-weight: normal;">Status:</label>
				<select class="uk-select" name="bu_id" v-model="selectedStatus">
					<option v-for="status in statuses" :value="status.id">{{ status.name }}</option>
				</select>
			</div>
			<div class="uk-form-controls uk-width-1-6">
				<label class="uk-form-label" style="font-weight: normal;">Managed By:</label>
				<select class="uk-select" name="contact_id" v-model="selectedUserId" >
					<option value="" >-- SELECT USER --</option>
					<option v-for="val in users" :value="val.id" >{{val.full_name}}</option>
				</select>
			</div>
			<div class="uk-form-controls uk-width-1-6">
				<p class="uk-form-label" style="font-weight: normal;">View:</p>
				<label class="uk-form-label uk-display-block">
					<input type="radio" class="uk-radio" value="placement" name="placement_type" v-model="assignType">
					Placements
				</label>
				<label class="uk-form-label uk-display-block">
					<input type="radio" class="uk-radio" value="candidate" name="placement_type" v-model="assignType">
					Candidates
				</label>

			</div>
		</div>
		<div class="uk-grid work-area">
			<div class="uk-width-1-6@xl uk-width-1-4@m uk-width-1-3">
				<div class="employee-list">
					<h3 class="uk-heading-tertiary" style="margin-bottom: -5px;">Available Employees <i class="fas fa-question primary-color is-clickable title-help" @click="displayEmpHelp"></i></h3>
					<small>Drag Employees to assign them</small>
					<div class="border-box">
						<div class="search-area">
							<div class="">Filter By <i class="fas fa-caret-square-down"></i></div>
							<div uk-dropdown>
								<div class="search-area-header">Scheduled</div>
								<div class="uk-column-1-2">
									<div>
										<label>
											<input class="uk-radio" type="radio" name="show_all" value="0"
												   v-model="showAll"/> Available Only
										</label>
									</div>
									<div>
										<label>
											<input class="uk-radio" type="radio" name="show_all" value="1"
												   v-model="showAll"/> Show All
										</label>
									</div>
								</div>
								<div class="search-area-header">Crafts</div>
								<div class="uk-column-1-2">
									<div v-for="craft in crafts">
										<label><input class="uk-checkbox" type="checkbox" :value="craft.id"
													  v-model="craftIds"> {{ craft.name }}</label>
									</div>
								</div>
								<div v-if="certifications.length > 0" class="search-area-header">Certifications</div>
								<div v-if="certifications.length > 0" class="uk-column-1-2">
									<div v-for="cert in certifications">
										<label><input class="uk-checkbox" type="checkbox" :value="cert.id"
													  v-model="certificationIds"> {{ cert.name }}</label>
									</div>
								</div>
								<div v-if="trainings.length > 0" class="search-area-header">Training</div>
								<div v-if="trainings.length > 0" class="uk-column-1-2">
									<div v-for="train in trainings">
										<label><input class="uk-checkbox" type="checkbox" :value="train.id"
													  v-model="trainingIds"> {{ train.name }}</label>
									</div>
								</div>

							</div>
							<div class="employee-list-filters">
                                <span v-for="craftId in craftIds" class="tag">{{ getCraftName(craftId) }}
                                    <i @click="dropCraftId(craftId)" class="fas fa-times"></i>
                                </span>
								<span v-for="certId in certificationIds" class="tag">{{ getCertName(certId) }}
                                    <i @click="dropCertId(certId)" class="fas fa-times"></i>
                                </span>
								<span v-for="trainingId in trainingIds" class="tag">{{ getTrainingName(trainingId) }}
                                    <i @click="dropTrainingId(trainingId)" class="fas fa-times"></i>
                                </span>
							</div>
							<input v-if="!activeSearch" class="uk-input" type="text" v-model="searchString"
                                   placeholder="Search Employees"
                            />
							<input v-if="activeSearch" class="uk-input telling-field" type="text" v-model="searchString"
                                   placeholder="Search Employees"
                                   :class="{edited:searchingDirty, saving:searchingEmployees}"
                                   @keydown.enter="newEmployeeSearch"
                                   @change="markDirtySearch" @keydown="markDirtySearch"
                            />
						</div>
						<div class="list" @dragover.prevent @drop="droppedOnList()" @scroll="testScroll">
							<div v-for="employee in employees" draggable="true" @contextmenu="showName($event, employee)"
								 @dragstart="startDrag(employee.id)" @dragend="endDrag()"
								 :class="{scheduled:employee.scheduleCount == 1, danger:employee.scheduleCount > 1 || employee.marked || employee.onProbation || employee.is_inactive}"
							>
								<i class="fas fa-bars"></i>
								{{ employee.full_name }}
								<i class="fas fa-circle" v-if="employee.scheduleCount == 1"></i>
								<i class="fas fa-question-circle" v-if="employee.is_conditional"></i>
								<i class="fas fa-exclamation-triangle"
								   v-if="employee.scheduleCount > 1 || employee.marked || employee.onProbation"></i>
								<i class="fas fa-times-circle" v-if="employee.is_inactive"></i>

							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="uk-width-5-6@xl uk-width-3-4@m uk-width-2-3 requisitions" style="padding-left:15px;">
				<h3 class="uk-heading-tertiary">Requisitions to be filled <i class="fas fa-question primary-color is-clickable title-help" @click="displayReqHelp"></i></h3>
				<div v-if="requisitions.length == 0 && !loadingReqs">
					No Requisitions Found
				</div>
                <div v-if="loadingReqs">
                    <img src="/images/spinner.svg" style="width: 18px;" />
                    Loading...
                </div>
                <div class="work-area-grid">
                    <div class="work-area-requisition border-box" v-for="requisition in requisitions">
                        <div class="work-area-requisition-header uk-grid">
                            <div class="uk-width-1-6" @click="toggleItem(requisition.id)">
                                <i class="fas fa-plus-square primary-color" v-if="isHidden(requisition.id)"></i>
                                <i class="fas fa-minus-square primary-color" v-if="!isHidden(requisition.id)"></i>
                            </div>
                            <div class="uk-width-2-3">
                                <h3 class="uk-heading-tertiary uk-text-center" style="margin-bottom: 0;"><a
                                    :href="'/requisitions/view/' + requisition.id">{{ requisition.name ?
                                    requisition.name:requisition.number }}
                                    <span v-if="requisition.customer">| {{requisition.customer }}</span>
                                    <span v-if="requisition.business_unit">| {{requisition.business_unit.name }}</span>
                                </a></h3>
                            </div>
                            <div class="uk-width-1-6">
                                <div v-show="false" class="shift-tag" v-for="shift in requisition.dates">
                                    <div class="shift-tag-name">{{ shift.name }}</div>
                                    <div class="shift-tag-count">{{ shiftSchedCount(shift, requisition) }} Assigned</div>
                                </div>
                            </div>
                        </div>
                        <transition name="collapse">
                            <div class="work-area-requisition-slots" v-show="!isHidden(requisition.id)">
                                <div class="shift-data" v-for="shift in requisition.dates">
                                    <h3 class="uk-heading-tertiary" style="margin-top: 10px;margin-bottom: 5px;">{{ shift.name }}
                                        <small>({{ fDate(shift.start_date) }}
                                            - {{ fDate(shift.end_date) }})</small>
                                        <span class="shift-tag-line">
                                        {{ shiftSchedCount(shift, requisition) }} Assigned
                                    </span>
                                    </h3>
                                    <div class="uk-grid">
                                        <!-- grouped jobs -->
                                        <div
                                            v-for="(group, i) in shift.sortedJobGroups"
                                            v-if="group.length > 0"
                                            class="sort-group"
                                            :class="columnClass(group, shift)"
                                        >
                                            <div class="work-area-requisition-slot"
                                                v-for="(job, i) in group"
												:class="{'candidate-list':isCandidate}"
                                                @dragover.prevent @drop="dragDropped(job.id)">
                                                <div class="job-name" @contextmenu="showJobDetails($event, job, requisition)" >{{ job.name }}
                                                    <span v-if="job.placements.length > job.quantity" class="job-name-overload">
                                                        (+{{ job.placements.length -  job.quantity}})
                                                    </span>
	                                                <i v-if="isCandidate" class="fas fa-ban is-clickable primary-color" @click.prevent="confirmClearCandidates(requisition, job, i)"></i>
                                                </div>
												<div class="job-date">({{ fDate(job.start_date) }}
													- {{ fDate(job.end_date) }})</div>
                                                <div v-if="!hasNote(job, i)" class="job-note-icon" @click="loadNotes(job, i)">
                                                    <img src="/images/note_empty.svg"/>
                                                </div>
                                                <div v-if="hasNote(job, i)" class="job-note-icon active" @click="loadNotes(job, i)">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="21.733" height="23.954" viewBox="0 0 21.733 23.954">
                                                        <g id="Group_1516" data-name="Group 1516" transform="translate(-1332 -1381.001)">
                                                            <path id="Path_109" data-name="Path 109" d="M197.127,358.066c-.021,0-.041.008-.062.009a1.557,1.557,0,0,1,.579.078A1.6,1.6,0,0,0,197.127,358.066Z" transform="translate(1155.055 1027.863)" fill="#004993"/>
                                                            <path id="Path_110" data-name="Path 110" d="M197.062,358.088a1.506,1.506,0,0,0-.266.044l.017.021A1.692,1.692,0,0,1,197.062,358.088Z" transform="translate(1154.899 1027.876)" fill="#004993"/>
                                                            <path id="Path_111" data-name="Path 111" d="M197.664,375.746c.3-.406,1.089-1.2,2.775-3.138.645-.742.489-.595,2.786-7.215l0,0c1.714-4.949,1.741-4.954,1.741-5.254h0a1.522,1.522,0,0,0-2.013-1.63l-.017-.021a1.576,1.576,0,0,0-1.006.982,2.17,2.17,0,0,1,.209-1.679c-.768-.417-.157-.294-13.526-.294a2.365,2.365,0,0,0-2.372,2.356v15.226a2.365,2.365,0,0,0,2.372,2.356H201.02a2.362,2.362,0,0,0,2.356-2.356v-3.259C202.263,372.823,199.33,375.294,197.664,375.746Zm-7.2-2.274a.791.791,0,1,1,0-1.581h7.5l.12,1.581Zm7.855-3.6h-7.855a.791.791,0,1,1,0-1.581h8.4Zm1.246-3.6h-9.1a.791.791,0,1,1,0-1.581c7.226,0,9.393-.006,9.645.008Zm-9.891-4.386a.79.79,0,0,1,.791-.791h8.682a.791.791,0,1,1,0,1.581h-8.682A.79.79,0,0,1,189.678,361.9Z" transform="translate(1148.763 1027.521)" />
                                                            <circle id="Ellipse_1" data-name="Ellipse 1" cx="5" cy="5" r="5" transform="translate(1332 1381.001)" fill="#31a848"/>
                                                        </g>
                                                    </svg>
                                                </div>
                                                <div class="divider thin"></div>
                                                <div v-if="requestIsLoading(job.id)">
                                                    <img  src="/images/spinner2.gif" style="width: 18px;" />
                                                    Loading...
                                                </div>
                                                <transition-group name="collapse">
                                                    <div v-for="placement in job.placements" draggable="true"
                                                         :class="{placement:isPlacement,candidate:isCandidate,accepted:!!placement.placement,danger:employeeNeedsAlert(placement.person)}"
                                                         @contextmenu="showName($event, placement.person)"
                                                         @dragstart="startDrag(placement.person_id, placement.id,job.id)"
                                                         @dragend="endDrag()"
                                                         :key="placement.id"
                                                    >
                                                        <i class="fas fa-bars"></i>
	                                                    <template v-if="isPlacement">
		                                                    {{ placement.name }} {{ job.placements && job.placements.length }}
	                                                    </template>
                                                        <template v-if="isCandidate">
	                                                        {{ placement.name }} {{ countPlacements(job) }}
                                                        </template>
                                                        <i class="fas fa-exclamation-triangle"
                                                           v-if="employeeNeedsAlert(placement.person)"></i>
                                                        <i class="fas fa-circle" v-if="placement.person.scheduleCount > 0"></i>
                                                        <i class="fas fa-check clickable candidate-control-item" v-if="isCandidate && !placement.placement" @click.prevent="acceptCandidate(placement)"></i>
                                                    </div>
                                                </transition-group>
                                                <transition-group name="collapse">
                                                    <div v-for="i in countBoxes(job)"
                                                         class="drop-point"
                                                         :key="'np_' + job.id + '_' + i"
                                                    >Drag Employee Here</div>
                                                </transition-group>
                                                <div class="uk-clearfix"></div>
                                            </div>
                                        </div>
                                        <!-- unsorted jobs -->
                                        <div class="work-area-requisition-slot"
                                             v-for="(job, i) in shift.unsortedJobs"
                                             :class="columnClass([job], shift)"
                                             v-if="job.shift.id == shift.id" @dragover.prevent @drop="dragDropped(job.id)">
                                            <div class="job-name" @contextmenu="showJobDetails($event, job, requisition)" >{{ job.name }}
                                                <span v-if="job.placements.length > job.quantity" class="job-name-overload">
                                                        (+{{ job.placements.length -  job.quantity}})
                                                </span>
	                                            <i v-if="isCandidate" class="fas fa-ban is-clickable primary-color" @click.prevent="confirmClearCandidates(requisition, job, i)"></i>
                                            </div>
											<div class="job-date">({{ fDate(job.start_date) }}
												- {{ fDate(job.end_date) }})</div>
                                            <div v-if="!hasNote(job, i)" class="job-note-icon" @click="loadNotes(job, i)">
                                                <img src="/images/note_empty.svg"/>
                                            </div>
                                            <div v-if="hasNote(job, i)" class="job-note-icon active" @click="loadNotes(job, i)">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="21.733" height="23.954" viewBox="0 0 21.733 23.954">
                                                    <g id="Group_1516" data-name="Group 1516" transform="translate(-1332 -1381.001)">
                                                        <path id="Path_109" data-name="Path 109" d="M197.127,358.066c-.021,0-.041.008-.062.009a1.557,1.557,0,0,1,.579.078A1.6,1.6,0,0,0,197.127,358.066Z" transform="translate(1155.055 1027.863)" fill="#004993"/>
                                                        <path id="Path_110" data-name="Path 110" d="M197.062,358.088a1.506,1.506,0,0,0-.266.044l.017.021A1.692,1.692,0,0,1,197.062,358.088Z" transform="translate(1154.899 1027.876)" fill="#004993"/>
                                                        <path id="Path_111" data-name="Path 111" d="M197.664,375.746c.3-.406,1.089-1.2,2.775-3.138.645-.742.489-.595,2.786-7.215l0,0c1.714-4.949,1.741-4.954,1.741-5.254h0a1.522,1.522,0,0,0-2.013-1.63l-.017-.021a1.576,1.576,0,0,0-1.006.982,2.17,2.17,0,0,1,.209-1.679c-.768-.417-.157-.294-13.526-.294a2.365,2.365,0,0,0-2.372,2.356v15.226a2.365,2.365,0,0,0,2.372,2.356H201.02a2.362,2.362,0,0,0,2.356-2.356v-3.259C202.263,372.823,199.33,375.294,197.664,375.746Zm-7.2-2.274a.791.791,0,1,1,0-1.581h7.5l.12,1.581Zm7.855-3.6h-7.855a.791.791,0,1,1,0-1.581h8.4Zm1.246-3.6h-9.1a.791.791,0,1,1,0-1.581c7.226,0,9.393-.006,9.645.008Zm-9.891-4.386a.79.79,0,0,1,.791-.791h8.682a.791.791,0,1,1,0,1.581h-8.682A.79.79,0,0,1,189.678,361.9Z" transform="translate(1148.763 1027.521)" />
                                                        <circle id="Ellipse_1" data-name="Ellipse 1" cx="5" cy="5" r="5" transform="translate(1332 1381.001)" fill="#31a848"/>
                                                    </g>
                                                </svg>
                                            </div>
                                            <div class="divider thin"></div>
                                            <transition name="collapse">
                                                <div v-if="job.placements.length == 0" class="drop-point">Drag Employee Here</div>
                                            </transition>
                                            <div v-if="requestIsLoading(job.id)">
                                                <img  src="/images/spinner2.gif" style="width: 18px;" />
                                                Loading...
                                            </div>
                                            <transition-group name="collapse">
                                                <div v-for="placement in job.placements" draggable="true" class="placement"
                                                     :class="{placement:isPlacement,candidate:isCandidate,accepted:!!placement.placement,danger:employeeNeedsAlert(placement.person)}"
                                                     @contextmenu="showName($event, placement.person)"
                                                     @dragstart="startDrag(placement.person_id, placement.id,job.id)"
                                                     @dragend="endDrag()"
                                                     :key="placement.id"
                                                >
                                                    <i class="fas fa-bars"></i>
                                                    {{ placement.name }}
                                                    <i class="fas fa-exclamation-triangle"
                                                       v-if="employeeNeedsAlert(placement.person)"></i>
                                                    <i class="fas fa-circle" v-if="placement.person.scheduleCount > 0"></i>
	                                                <i class="fas fa-check clickable candidate-control-item" v-if="isCandidate && !placement.placement" @click.prevent="acceptCandidate(placement)"></i>
                                                </div>
                                            </transition-group>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
			</div>
			<div class="uk-clearfix"></div>
		</div>
		<div ref="helpEmpModal" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<h2 class="uk-modal-title">Available Employees</h2>
				<div>
					<p>Displays a list of employees based on search criteria.</p>
				</div>
				<div>
					<p>Hover over "Filter By" to get additional filter options.</p>
				</div>
				<div>
					<p>Right click an employee name to get additional information such as average rating, craft skills,
						and more.</p>
				</div>
				<div>
					<p>Click and drag employee to a job on the right.</p>
				</div>
				<div>
					<p><i class="fas fa-exclamation-triangle uk-text-danger"></i> Shows the employee is in a status the may require
						investigation.</p>
				</div>
				<div>
					<p><i class="fas fa-circle primary-color"></i> Shows the employee is scheduled during the time of one or more
						requisitions being displayed.</p>
				</div>
				<div>
					<p><i class="fas fa-exclamation-triangle uk-text-danger"></i> Shows the employee is in a status the may require
						investigation.</p>
				</div>
				<div>
					<p><i class="fas fa-question-circle"></i> Shows the employee is a conditional rehire.</p>
				</div>
				<div>
					<p><i class="fas fa-times-circle uk-text-danger"></i> Shows the employee is not currently active with the company and should not be used.</p>
				</div>
				<div class="uk-margin-medium-bottom"></div>
				<button class="uk-button uk-button-primary uk-modal-close" type="button">Ok</button>
			</div>
		</div>
		<div ref="helpReqModal" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<h2 class="uk-modal-title">Help</h2>
				<div>
					<p>Displays requisitions with active dates within the above date ranges, and as specified by
						the other filters.</p>
				</div>
				<div>
					<p>Click and drag an employee to a different location to change their job, or drag them back to the
						employee list on the left to remove them completely.</p>
				</div>
				<div>
					<p>Right click an employee name to get additional information such as average rating, craft skills,
						and more.</p>
				</div>
				<div>
					<p>In <span class="candidate-text">candidate mode</span>, the employee will first be established as
						a candidate. Having someone as a candidate does not affect other portions of the site.
						Additionally, candidates will not display in the Placements view.</p>
					<p class="candidate">Candidates will show in green with a dotted green border.</p>
					<p><i class="fas fa-check candidate-text"></i> Click the check mark to accept
						the employee and officially assign them to the job.</p>
					<p><i class="fas fa-ban primary-color"></i> Click to clear out all job candidates when
					all needed job positions are filled.</p>
				</div>
				<div>
					<p>Note: on older requisitions, employees already placed on the job may not show in the Candidates
						view.</p>
				</div>

				<div class="uk-margin-medium-bottom"></div>
				<button class="uk-button uk-button-primary uk-modal-close" type="button">Ok</button>
			</div>
		</div>
	</div>
</template>

<script>
	import EmployeeCard from "./EmployeeCard";
	import JobCard from "./JobCard";
	import GlobalStorage from "../Classes/GlobalStorage";
	import Format from "../Classes/Format";
	import Datepicker from "vuejs-datepicker";

	export default {
		name: "DayScheduling",

		components: {
			EmployeeCard,
			JobCard,
			Format,
			Datepicker
		},

		props: {
			defaultDistance: {
				type: Number,
				default: 14
			},
			nid: {type:String, default:null}, //Note box ID
			displayHours:{type:Boolean, default:false},
            activeSearch:{type:Boolean, default:true},
		},

		data() {
			return {
				startDate: null,
				endDate: null,
				scrollData: {
					startTop: 0,
					employeeListElement: null,
				},
				searchString: "",
                searchingDirty: false,
				employees: [],
				requisitions: [],
				showAll: 1,
				//personFilters: [],
				craftIds: [],
				crafts: [],
				trainings: [],
				trainingIds: [],
				certifications: [],
				certificationIds: [],
				draggingId: 0,
				draggingPlacementId: 0,
				transferFromJob: 0,
				typeCount: 0,
				scrollPage: 1,
				employeePagination: null,
				paging: false,
                loadingReqs: false,
				hideList: [],
				loadingRequests: [],
				businessUnits: [],
				businessUnitId: null,
				buLoaded: false,
                searchingEmployees: false,
				assignType: "placement", // or candidate
				statuses:[
					{
						id:"",
						name:" -- "
					},
					{
						id:"new",
						name:"New"
					},
					{
						id:"open",
						name:"Open"
					},
					{
						id:"in progress",
						name:"In Progress"
					},
					{
						id:"fulfilled",
						name:"Fulfilled"
					},
					{
						id:"completed",
						name:"Completed"
					},
				],
				selectedStatus: "",
				users:[],
				usersLoaded:[],
				selectedUserId: ""
			};
		},

		mounted() {
			this.startDate = new Date();
			if (GlobalStorage.has("schedule_start_offset")) {
				this.startDate.setDate(this.startDate.getDate() + GlobalStorage.load("schedule_start_offset"));
			}
			let end = new Date(this.startDate);
			if (GlobalStorage.has("schedule_distance")) {
				end.setDate(this.startDate.getDate() + GlobalStorage.load("schedule_distance"));
			} else {
				end.setDate(this.startDate.getDate() + this.defaultDistance);
			}

			if(GlobalStorage.has("schedule_closed_items")){
			    this.hideList = GlobalStorage.load("schedule_closed_items");
            }

			if (GlobalStorage.has("schedule_selected_status")) {
				this.selectedStatus = GlobalStorage.load("schedule_selected_status");
			}

			if (GlobalStorage.has("schedule_selected_user")) {
				this.selectedUserId = GlobalStorage.load("schedule_selected_user");
			}

			this.endDate = end;

			this.scrollData.employeeListElement = document.querySelector(".employee-list");
			this.scrollData.startTop = this.scrollData.employeeListElement.getBoundingClientRect().top + window.pageYOffset;
			window.addEventListener("scroll", this.checkScroll.bind(this));

			this.searchEmployees();
			this.loadBusinessUnits();
			axios.get("/api/users/all").then((pack) => this.updateUsersList(pack));
			setTimeout(() => this.calculateListHeight(), 1);
			window.addEventListener("resize", () => this.calculateListHeight());
		},

		methods: {
			searchEmployees() {
                this.searchingEmployees = true;
                this.searchingDirty = false;
                this.$forceUpdate();
				let sd = (this.startDate.getUTCMonth() + 1) + "/" + this.startDate.getUTCDate() + "/" + this.startDate.getUTCFullYear();
				let ed = (this.endDate.getUTCMonth() + 1) + "/" + this.endDate.getUTCDate() + "/" + this.endDate.getUTCFullYear();
				axios.get("/api/scheduling/employees",
					{
						params: {
							q: this.searchString,
							start_date: sd,
							end_date: ed,
							show_all: this.showAll,
							craft_ids: this.craftIds,
							certification_ids: this.certificationIds,
							training_ids: this.trainingIds,
							sort: "full_name",
							limit: 50,
							page: this.searchingDirty ? 1:this.scrollPage
						}
					}).then(
					ax => this.updateEmployees(ax),
					() => this.clearEmployees()
				);
			},
			updateEmployees(pack) {
			    this.searchingEmployees = false;
				if (pack.data.success) {
					this.employeePagination = pack.data.pagination;
					if (this.employeePagination.page <= 1) {
					    this.scrollPage = 1;
						this.employees = pack.data.data;
					} else {
						this.employees = this.employees.concat(pack.data.data);
					}
				}
				this.paging = false;
			},
			loadBusinessUnits(){
				axios.get("/api/bu/list").then(
					ax => this.updateBusinessUnits(ax),
					ax => this.updateBusinessUnits(ax))
			},
			updateBusinessUnits(pack) {
				this.buLoaded = true;
				if(pack.data.success){
					this.businessUnits = pack.data.data;
				}

				if(GlobalStorage.has("schedule_business_unit")){
					let buId = GlobalStorage.load("schedule_business_unit");
					if(this.businessUnits.length > 0){
						for(let i = 0; i < this.businessUnits.length;++i){
							let bu = this.businessUnits[i];
							if(bu.id == buId){
								this.businessUnitId = buId;
								break;
							}
						}
						if(buId == 0){
							this.businessUnitId = buId;
						}
						if(this.businessUnitId == null){
							this.businessUnitId = this.businessUnits[0].id;
						}
					}
				} else if(this.businessUnits.length > 0) {
					this.businessUnitId = this.businessUnits[0].id;
				}
				if(this.businessUnitId == null){
					this.businessUnitId = 0;
				}
			},
			updateUsersList(pack){
				this.usersLoaded = true;
				if(pack.data.success){
					this.users = pack.data.data;
				}
			},
			clearEmployees() {
                this.searchingEmployees = false;
				if (this.scrollPage < 2) {
					this.employees = [];
				}
			},
            markDirtySearch(){
			    if(!this.searchingDirty && !this.searchingEmployees){
                    this.searchingDirty = true;
                    this.$forceUpdate();
                }
            },
			pageEmployees() {
				if (!this.paging) {
					this.paging = true;
					this.scrollPage++;
					if (this.employeePagination == null || this.employeePagination.totalPages >= this.scrollPage) {
						this.searchEmployees();
					}
				}
			},
			apiSearch() {
				this.typeCount--;
				if (this.typeCount <= 0) {
					this.scrollPage = 1; //reset the pagination
					!this.loadingStorage ? this.searchEmployees() : null;
					this.loadingStorage = false;
				}
			},
            newEmployeeSearch(){
                this.scrollPage = 1; //reset the pagination
                this.searchEmployees();
            },
			searchRequisitions() {
				if(!this.buLoaded || !this.usersLoaded){
					return;
				}
			    this.loadingReqs = true;
				let sd = (this.startDate.getUTCMonth() + 1) + "/" + this.startDate.getUTCDate() + "/" + this.startDate.getUTCFullYear();
				let ed = (this.endDate.getUTCMonth() + 1) + "/" + this.endDate.getUTCDate() + "/" + this.endDate.getUTCFullYear();
				axios.get("/api/scheduling/requisitions", {
					params: {
						start: sd,
						end: ed,
						bu_id: this.businessUnitId,
						status: this.selectedStatus,
						user_id: this.selectedUserId
					}
				}).then(
					ax => this.updateRequisitions(ax),
                    ax => this.updateRequisitions(ax)
				);
			},
			updateRequisitions(pack) {
			    this.loadingReqs = false;
				if (pack.data.success) {
					this.requisitions = pack.data.data;
				}
				//populate needed crafts, trainings, and certifications
				for (let i = 0; i < this.requisitions.length; ++i) {
					let req = this.requisitions[i];
					//extract needed crafts
                    //sort jobRequests
                    req.jobRequests.sort(function(j1, j2){
                        if(j1.skill.position_x == j2.skill.position_x){
                            if(j1.skill.position_y < j2.skill.position_y){
                                return -1;
                            } else if(j1.skill.position_y > j2.skill.position_y){
                                return 1;
                            }
                        }
                        if(j1.skill.position_x < j2.skill.position_x){
                            return -1;
                        } else if(j1.skill.position_x > j2.skill.position_x){
                            return 1;
                        }
                        return 0;
                    });
                    //add sorted and unsorted arrays to all the shifts
                    for(let s = 0; s < req.dates.length; ++s){
                        req.dates[s].sortedJobGroups = [];
                        req.dates[s].unsortedJobs = [];
                    }
					for (let j = 0; j < req.jobRequests.length; ++j) {
						let request = req.jobRequests[j];
						let found = false;
						//find the shift
                        let shift = null;
                        for(let q = 0; q < req.dates.length;++q){
                            if(req.dates[q].id === request.shift.id){
                                shift = req.dates[q];
                            }
                        }
                        if(shift){ //this should never be null, but just to be sure...
                            if(!request.placements){ //and in case placements didn't come through...
                                request.placements = [];
                            }
                            if(request.skill.position_x === null){
                                shift.unsortedJobs.push(request);
                            } else {

                                while(shift.sortedJobGroups.length <= request.skill.position_x){
                                    shift.sortedJobGroups.push([]);
                                }
                                while(shift.sortedJobGroups[request.skill.position_x].length <= request.skill.position_y){
                                    shift.sortedJobGroups[request.skill.position_x].push({id:0,placements:[]});
                                }
                                if(shift.sortedJobGroups[request.skill.position_x][request.skill.position_y].id !== 0){
                                    console.warn("Replacement happening");
                                }
                                shift.sortedJobGroups[request.skill.position_x][request.skill.position_y] = request;
                            }
                        }

						this.loadPlacements(request.id, req.id);
						for (let k = 0; k < this.crafts.length; ++k) {
							if (this.crafts[k].id == request.skill_id) {
								found = true;
								break;
							}
						}
						if (!found) {
							this.crafts.push({
								id: request.skill_id,
								name: request.name
							});
						}
						for (let k = 0; k < request.trainings.length; ++k) {
							this.pushTraining({
								id: request.trainings[k].id,
								name: request.trainings[k].name
							});
						}
						for (let k = 0; k < request.certifications.length; ++k) {
							this.pushCertification({
								id: request.certifications[k].id,
								name: request.certifications[k].name
							});
						}
					}

					//clean house (remove empty job groups)
					for(let s = 0; s < req.dates.length; ++s){
						for(let jg = 0; jg < req.dates[s].sortedJobGroups.length; ++jg){
                            //clear blank placements
                            for(let ji = 0; ji < req.dates[s].sortedJobGroups[jg].length;++ji){
                                if(req.dates[s].sortedJobGroups[jg][ji].id === 0){
                                    req.dates[s].sortedJobGroups[jg].splice(ji, 1);
                                    ji--;
                                }
                            }
                            //if column empty, drop that as well
							if(req.dates[s].sortedJobGroups[jg].length === 0){
								req.dates[s].sortedJobGroups.splice(jg, 1);
								jg--;
							}
						}
					}

					//extract needed trainings
					for (let k = 0; k < req.trainings.length; ++k) {
						this.pushTraining({
							id: req.trainings[k].id,
							name: req.trainings[k].name
						});
					}
					//extract needed certifications
					for (let k = 0; k < req.certifications.length; ++k) {
						this.pushCertification({
							id: req.certifications[k].id,
							name: req.certifications[k].name
						});
					}
				}
			},
			loadPlacements(jobId, requisitionId){
				this.loadingRequests.push(jobId);
				let apiPoint = "/api/requisition/placements/";
				if(this.isCandidate){
					apiPoint = "/api/scheduling/candidate/get/";
				}
				axios.get(apiPoint+jobId, {
					params:{
						skipDropped: true
					}
				}).then(
					ax => this.updateLoadedPlacements(ax, jobId, requisitionId),
					ax => this.updateLoadedPlacements(ax, jobId, requisitionId)
				);
			},
			updateLoadedPlacements(pack, jobId = null, requisitionId = null){
				if(pack.data.success){
					let placements = pack.data.data;
					if(placements.length > 0){
						if(jobId == null){
							jobId = placements[0].job_request_id;
						}
						if(requisitionId == null){
							requisitionId = placements[0].requisition_id;
						}
						for(let i = 0; i < this.requisitions.length;++i){
							if(this.requisitions[i].id == requisitionId){
								for(let j = 0; j < this.requisitions[i].jobRequests.length;++j){
									if(this.requisitions[i].jobRequests[j].id == jobId){
										this.requisitions[i].jobRequests[j].placements = placements;
										break;
									}
								}
								break;
							}
						}
					} else if(jobId != null) {
                        for (let i = 0; i < this.requisitions.length; ++i) {
                            for (let j = 0; j < this.requisitions[i].jobRequests.length; ++j) {
                                if (this.requisitions[i].jobRequests[j].id == jobId) {
                                    this.requisitions[i].jobRequests[j].placements = placements;
                                }
                            }
                        }
                    }
				}
				if(jobId != null){
					let index = this.loadingRequests.indexOf(jobId);
					index > -1 ? this.loadingRequests.splice(index, 1):null;
				}
			},
			requestIsLoading(jobId){
				let index = this.loadingRequests.indexOf(jobId);
				return index > -1;
			},
			startDateSet(val) {
				this.startDate = val;
				let timeDiff = this.startDate.getTime() - Date.now();
				let dayDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
				GlobalStorage.save("schedule_start_offset", dayDiff);
				this.saveDateDistance();
				this.searchRequisitions();
			},
			endDateSet(val) {
				this.endDate = val;
				this.saveDateDistance();
				this.searchRequisitions();
			},
			saveDateDistance() {
				let timeDiff = this.endDate.getTime() - this.startDate.getTime();
				let dayDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
				GlobalStorage.save("schedule_distance", dayDiff);
			},
			checkScroll() {
				if (window.pageYOffset > this.scrollData.startTop) {
					this.scrollData.employeeListElement.classList.add("fixed");
				} else {
					this.scrollData.employeeListElement.classList.remove("fixed");
				}
			},

			startDrag(empId, placementId = 0, oldJobId = 0) {
				this.draggingId = empId;
				this.transferFromJob = oldJobId;
				this.draggingPlacementId = placementId;
				this.$refs.card.hide();
			},
			endDrag() {
				this.draggingId = 0;
				this.transferFromJob = 0;
				this.draggingPlacementId = 0;
			},
			dragDropped(jobId) {
				let employee = null;
				let empIndex = this.getEmployeeIndex(this.draggingId);
				if(empIndex > -1){
					employee = this.employees[empIndex];
				}
				if (this.draggingPlacementId != 0) {
					let placementId = this.draggingPlacementId;
					let draggingId = this.draggingId;
					let fromJobId = this.transferFromJob;
					this.movePlacement(placementId, draggingId, jobId, fromJobId);
					if (employee) {
						employee.scheduleCount--;
					}
					return;
				}

				this.checkPlacement(jobId, this.draggingId, empIndex);
			},
			getEmployeeIndex(employeeId){
				let empIndex = -1;
				for (let i = 0; i < this.employees.length; ++i) {
					if (this.employees[i].id == employeeId) {
						empIndex = i;
						break;
					}
				}
				return empIndex;
			},
            checkPlacement(jobId, pid, empIndex){
                axios.post("/api/scheduling/check/" + jobId, {
                    pid: pid
                }).then(
                    (pack) => this.verifyPlacement(jobId, pid, empIndex, pack),
                );
            },
            verifyPlacement(jobId, pid, empIndex, pack){
			    if(pack.data.success){
			        if(pack.data.data.conflictCount > 0){
			            let confirmText = "<div>This employee has the following conflicts:</div>";
			            for(let i = 0; i < pack.data.data.conflicts.length;++i){
			                let conflict = pack.data.data.conflicts[i];
			                if(conflict.requisition.name.length == 0){
                                confirmText += "<div>"+ conflict.requisition.number +"</div>";
                            } else {
                                confirmText += "<div>"+ conflict.requisition.name + ": " + conflict.requisition.customer +"</div>";
                            }
                        }
				        for(let i = 0; i < pack.data.data.softConflicts.length;++i){
					        let conflict = pack.data.data.softConflicts[i];
					        if(conflict.requisition.name.length == 0){
						        confirmText += "<div class='soft-conflict'>"+ conflict.requisition.number +"</div>";
					        } else {
						        confirmText += "<div class='soft-conflict'>"+ conflict.requisition.name + ": " + conflict.requisition.customer +"</div>";
					        }
				        }
			            confirmText +=  "<div style=\"margin-top: 5px;\">Do you want to add them anyway?</div>";
			            UIkit.modal.confirm(confirmText).then(
                            () => this.addPlacement(jobId, pid, empIndex),
                            () => function(){/*DO NOTHING*/}
                        );
                    } else {
			            this.addPlacement(jobId, pid, empIndex);
                    }
                } else {
                    UIkit.modal.alert("Sorry, you do not have the rights to assign this employee. Please discuss this addition to your manager and have them set the change.");
                }
            },
            addPlacement(jobId, pid, empIndex){
				let apiPoint = "/api/scheduling/assign/";
				if(this.isCandidate){
					apiPoint = "/api/scheduling/candidate/add/";
					empIndex = -1; //we don't want to count this as being added
				}
                axios.post(apiPoint + jobId, {
                    pid: pid
                }).then(
                    (pack) => this.updatePlacements(jobId, pack, empIndex),
                );
            },
			movePlacement(placementId, draggingId, jobId, fromJobId){
				let apiPoint = "/api/scheduling/assign/";
				if(this.isCandidate){
					apiPoint = "/api/scheduling/candidate/add/";
				}
				axios.post(apiPoint + jobId, {
					pid: draggingId
				}).then(
					(pack) => this.updatePlacements(jobId, pack, -1)
				);
				this.removePlacement(placementId, fromJobId);
			},
			droppedOnList() {
				let employee = null;
				for (let i = 0; i < this.employees.length; ++i) {
					if (this.employees[i].id == this.draggingId) {
						employee = this.employees[i];
						break;
					}
				}
				if (this.draggingPlacementId != 0) {
					if (employee) {
						employee.scheduleCount--;
					}
					this.removePlacement(this.draggingPlacementId, this.transferFromJob);
				}
			},
			removePlacement(pid, jobId) {
				let apiPoint = "/api/scheduling/remove/placement";
				if(this.isCandidate){
					apiPoint = "/api/scheduling/candidate/remove";
				}
				axios.post(apiPoint, {pid: pid}).then(
					() => this.loadPlacements(jobId),
					() => this.loadPlacements(jobId)
				);
			},
			updatePlacements(jobId, pack, empIndex) {
				if (pack.data.success) {
					let placements = pack.data.data;
					let reqId = placements[0].requisition_id;
					for (let i = 0; i < this.requisitions.length; ++i) {
						if (this.requisitions[i].id == reqId) {
							for (let j = 0; j < this.requisitions[i].jobRequests.length; ++j) {
								if (this.requisitions[i].jobRequests[j].id == jobId) {
									this.requisitions[i].jobRequests[j].placements = placements;
								}
							}
						}
					}

					if(empIndex > -1){
					    this.employees[empIndex].scheduleCount++;
                    }
				}
				else{
                    UIkit.modal.alert("Sorry, you do not have the rights to assign this employee. Please discuss this addition to your manager and have them set the change.");
                }
			},
			shiftSchedCount(shift, requisition) {
				let need = 0;
				let assigned = 0;
				for (let i = 0; i < requisition.jobRequests.length; ++i) {
					let job = requisition.jobRequests[i];
					if (job.shift.id == shift.id) {
						need += job.quantity;
						assigned += job.placements.length;
					}
				}
				return assigned;// + " / " + need;
			},
			showName(event, employee){
				event.preventDefault();
				this.displayCard(employee);
			},
            showJobDetails(event, job, requisition){
                event.preventDefault();
                this.$refs.jobCard.show(job, requisition);
                this.hideCard();
            },
            hideJobCard(){
                this.$refs.jobCard.hide();
            },
			displayCard(employee) {
				this.$refs.card.show(employee);
                this.hideJobCard();
			},
			hideCard() {
				this.$refs.card.hide();
			},
			calculateListHeight() {
				let borderBox = document.querySelector(".employee-list .border-box");
				let searchBox = borderBox.querySelector(".search-area");
				let listBox = borderBox.querySelector(".list");
				let targetHeight = borderBox.getBoundingClientRect().height - searchBox.getBoundingClientRect().height;
				targetHeight -= 5;
				listBox.style.height = targetHeight + "px";
			},
			testScroll(ev) {
				let scroll = ev.target.scrollTop + ev.target.clientHeight;
				let height = ev.target.scrollHeight;

				if (scroll >= (height - 3)) {
					this.pageEmployees();
				}
			},
			employeeNeedsAlert(employee) {
				if (employee.raw_notes.length == 0) {
					return false;
				}

				for (let i = 0; i < employee.raw_notes.length; ++i) {
					let alert = employee.raw_notes[i];
					if (alert.toLowerCase().indexOf("needs") > -1) {
						return true;
					}
				}

				return false;
			},
			pushTraining(item) {
				let found = false;
				for (let i = 0; i < this.trainings.length; ++i) {
					if (item.id == this.trainings[i].id) {
						found = true;
						break;
					}
				}

				if (!found) {
					this.trainings.push(item);
				}
			},
			pushCertification(item) {
				let found = false;
				for (let i = 0; i < this.certifications.length; ++i) {
					if (item.id == this.certifications[i].id) {
						found = true;
						break;
					}
				}

				if (!found) {
					this.certifications.push(item);
				}
			},
			getCraftName(id) {
				for (let i = 0; i < this.crafts.length; ++i) {
					if (this.crafts[i].id == id) {
						return this.crafts[i].name;
					}
				}
				return "";
			},
			getCertName(id) {
				for (let i = 0; i < this.certifications.length; ++i) {
					if (this.certifications[i].id == id) {
						return this.certifications[i].name;
					}
				}
				return "";
			},
			getTrainingName(id) {
				for (let i = 0; i < this.trainings.length; ++i) {
					if (this.trainings[i].id == id) {
						return this.trainings[i].name;
					}
				}
				return "";
			},
			dropCraftId(id) {
				var index = this.craftIds.indexOf(id);
				if (index !== -1) {
					this.craftIds.splice(index, 1);
				}
			},
			dropCertId(id) {
				var index = this.certificationIds.indexOf(id);
				if (index !== -1) {
					this.certificationIds.splice(index, 1);
				}
			},
			dropTrainingId(id) {
				var index = this.trainingIds.indexOf(id);
				if (index !== -1) {
					this.trainingIds.splice(index, 1);
				}
			},
			fDate(dt){
				return Format.formatDate(dt);
			},
			sDate(dt){
				return Format.shortDate(dt);
			},
			isHidden(id){
				return this.hideList.indexOf(id) > -1;
			},
			toggleItem(id){
				if(this.isHidden(id)){
					this.hideList.splice(this.hideList.indexOf(id), 1);
				}
				else {
					this.hideList.push(id);
				}

				GlobalStorage.save("schedule_closed_items", this.hideList);
			},
			getJobById(id){
				for(let r = 0; r < this.requisitions.length;++r){
					let requisition = this.requisitions[r];
					for(let i = 0; i < requisition.jobRequests.length;++i){
						if(requisition.jobRequests[i].id == id){
							return requisition.jobRequests[i];
						}
					}
				}
				return null;
			},
			loadNotes(craft, index){
				let notes = "";
				if(craft.notes && craft.notes.length > 0){
					notes = craft.notes[0].content;
				} else { //check note cache for existing note
					/*for(let i = 0; i < this.noteCaches.length;++i){
						if(this.noteCaches[i].index == index){
							notes = this.noteCaches[i].content;
							break;
						}
					}*/
				}
				this.$root.$refs[this.nid].loadNotes(notes, craft.id, index, this);
			},
			cacheBack(note, index){ //caching should never happen here
				/*let found = false;
				for(let i = 0; i < this.noteCaches.length;++i){
					if(this.noteCaches[i].index == index){
						this.noteCaches[i].content = note;
						found = true;
						break;
					}
				}
				if(!found){
					this.noteCaches.push({
						index: index,
						content: note
					});
				}*/

			},
			updateItem(note, jobId){
				let craft = this.getJobById(jobId);
				if(craft.notes.length < 1){
					craft.notes.push({
						content: note
					});
				} else {
					craft.notes[0].content = note;
				}
			},
			hasNote(craft, index){
				if(craft.notes && craft.notes.length > 0){
					return true;
				}

				return false;
			},
            findLargestCrew(group){
			    let largest = 0;
			    for(let i = 0; i < group.length;++i){
			        if(group[i].quantity > largest){
			            largest = group[i].quantity;
                    }
                }
			    group.largestCrew = largest;
			    return largest;
            },
			countColumns(shift){
				let numColumns = shift.sortedJobGroups.length + shift.unsortedJobs.length;
				for(let x = 0; x < shift.sortedJobGroups.length;++x){
					let topCount = this.findLargestCrew(shift.sortedJobGroups[x]);
					topCount >= 26 ? numColumns++:null;
					topCount >= 51 ? numColumns++:null;
					topCount >= 76 ? numColumns++:null;
				}
				for(let u = 0; u < shift.unsortedJobs.length;++u){
					let topCount = shift.unsortedJobs[u].quantity;
					topCount >= 26 ? numColumns++:null;
					topCount >= 51 ? numColumns++:null;
					topCount >= 76 ? numColumns++:null;
				}
				shift.countedColumns = numColumns;
				return numColumns;
			},
			columnClass(group, shift){
				let numColumns = shift.countedColumns ? shift.countedColumns:this.countColumns(shift);
				let crewSize = group.largestCrew ? group.largestCrew:this.findLargestCrew(group);
				let andAppend = "";
				if(this.isCandidate){
					andAppend = " candidate-list";
				}

				if(numColumns == 1){
					return "uk-width-1-1" + andAppend;
				}
                if(numColumns <= 2){
					return "uk-width-1-2" + andAppend;
				}
                if(numColumns <= 3){ //use 1/3 columns
                    if(crewSize < 51){
                        return "uk-width-1-3" + andAppend;
                    } else if (crewSize >= 51 && crewSize < 76){
                        return "uk-width-2-3" + andAppend;
                    }
                }
				if(numColumns <= 4){ // use 1/4 column sizes
					if(crewSize < 26){
						return "uk-width-1-4" + andAppend;
					} else if(crewSize >= 26 && crewSize < 51){
						return "uk-width-1-2" + andAppend;
					} else if (crewSize >= 51 && crewSize < 76){
						return "uk-width-3-4" + andAppend;
					}
				}
                if(numColumns <= 5){ //use 1/5 columns
                    if(crewSize < 26){
                        return "uk-width-1-5" + andAppend;
                    } else if(crewSize >= 26 && crewSize < 51){
                        return "uk-width-2-5" + andAppend;
                    } else if (crewSize >= 51 && crewSize < 76){
                        return "uk-width-3-5" + andAppend;
                    }
                }
                // use 1/6 column sizes
                if(crewSize < 26){
                    return "uk-width-1-6" + andAppend;
                } else if(crewSize >= 26 && crewSize < 51){
                    return "uk-width-1-3" + andAppend;
                } else if (crewSize >= 51 && crewSize < 76){
                    return "uk-width-2-3" + andAppend;
                }

				return "uk-width-1-1" + andAppend;
			},
            countBoxes(job){
                if(job.placements && job.placements.length){
                    if(job.quantity - job.placements.length > 0){
                        return job.quantity - job.placements.length;
                    } else {
                        return 0;
                    }
                }
                return job.quantity;
            },
			acceptCandidate(candidate){
				let empIndex = this.getEmployeeIndex(candidate.person_id);
				let apiPoint = "/api/scheduling/candidate/approve/";
				axios.post(apiPoint + candidate.id, {}).then(
					(pack) => this.updatePlacements(candidate.job_request_id, pack, empIndex),
				);
			},
			countPlacements(job){
				let total = 0;
				for(let i = 0; i < job.placements.length;++i){
					if(!!job.placements[i].placement){
						total++;
					}
				}

				return total;
			},
			displayEmpHelp(){
				UIkit.modal(this.$refs.helpEmpModal).show();
			},
			displayReqHelp(){
				UIkit.modal(this.$refs.helpReqModal).show();
			},
			confirmClearCandidates(requisition, job){
				UIkit.modal.confirm("Are you sure you want to remove all unconfirmed candidates for " + job.name +
					" in " + requisition.name + "?")
					.then(() => {this.clearCandidates(job)})
					.catch(() => {/*Nothing*/});
			},
			clearCandidates(job){
				axios.post("/api/scheduling/candidate/clear", {
					jid: job.id
				})
					.then((pack) => this.updatePlacements(job.id, pack, -1))
					.catch(() => {
						UIkit.modal.alert("A system error occurred and the process could not be completed.")
					});
			}
		},
		watch: {
			requisitions: {
				handler: function (val) {
					//hopefully the function just has to exist :P
				},
				deep: true
			},
			employees: {
				handler: function (val) {
					//hopefully the function just has to exist :P
				},
				deep: true
			},
			businessUnitId(){
				if(this.businessUnitId != null && typeof this.businessUnitId != "undefined"){
					this.searchRequisitions();
					GlobalStorage.save("schedule_business_unit", this.businessUnitId);
				}
			},
			selectedStatus(){
				if(this.selectedStatus != null && typeof this.selectedStatus != "undefined"){
					this.searchRequisitions();
					GlobalStorage.save("schedule_selected_status", this.selectedStatus);
				}
			},
			selectedUserId(){
				if(this.selectedUserId != null && typeof this.selectedUserId != "undefined"){
					this.searchRequisitions();
					GlobalStorage.save("schedule_selected_user", this.selectedUserId);
				}
			},
			searchString() {
			    if(this.activeSearch){
                    return;
                }
				this.typeCount++;
				setTimeout(() => this.apiSearch(), 400);
			},
			craftIds() {
				this.typeCount++;
				setTimeout(() => this.apiSearch(), 400);
				setTimeout(() => this.calculateListHeight(), 1);
			},
			certificationIds() {
				this.typeCount++;
				setTimeout(() => this.apiSearch(), 400);
				setTimeout(() => this.calculateListHeight(), 1);
			},
			trainingIds() {
				this.typeCount++;
				setTimeout(() => this.apiSearch(), 400);
				setTimeout(() => this.calculateListHeight(), 1);
			},
			showAll() {
				this.typeCount++;
				setTimeout(() => this.apiSearch(), 400);
			},
			assignType(){
				this.searchRequisitions();
			}
		},
		computed:{
			isCandidate(){
				return this.assignType=='candidate';
			},
			isPlacement(){
				return this.assignType=='placement';
			}
		}
	}
</script>
